<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "App",
  methods: {
    cekLogin() {
      window.OneSignal = window.OneSignal || [];
      window.OneSignal.push(function () {
        window.OneSignal.init({
          appId: process.env.ONE_SIGNAL,
        });
        if (localStorage.getItem("jwt") != null) {
          window.OneSignal.getUserId(function (userId) {
            axios
              .post(
                process.env.OS_URL,
                {
                  oneSignal: userId,
                },
                {
                  headers: {
                    "Asani-Token": localStorage.getItem("jwt"),
                  },
                }
              )
              .then((response) => {})
              .catch(error => {
                console.log(error);
              });
          });
        }
      });
    },
  },
  created() {
    this.cekLogin();
  },
};
</script>

<style>
.multiselect--disabled .multiselect__tags {
  background-color: #ededed;
}
.order_tag_input .multiselect__single {
  font-size: 0.875rem;
}
.app_input .multiselect--disabled .multiselect__single {
  font-size: 0.875rem;
  background-color: #e9ecef;
}

.alert-button {
  font-weight: 600;
  font-size: 20px;
  border-radius: 8px;
}

.alert-cancel-button {
  border: 1px solid #CFD3D9;
  color: #2E3646;
  background: transparent;
  
}

.alert-confirm-button-blue {
  color: #FFFFFF;
  background: #3098F7;
}

.alert-confirm-button-orange {
  color: #FFFFFF;
  background: #F57A1A;
}

.alert-confirm-button-red {
  color: #FFFFFF;
  background:#eb4d4b;
}

.alert-confirm:hover {
  color: #FFFFFF;
}

.fw-500 {
  font-weight: 500 !important;
}

#app {
}
</style>



// WEBPACK FOOTER //
// src/App.vue